export const CURRENT_VERSION = '1.2.0';
export const SAVED_STORE_KEY = 'my-app';